import { useState } from "react"

export const useImagePreview = () =>{
  const [fullScreen, setFullScreen] = useState(null);

  return {
    fullScreen,
    openPreview: (img)=>setFullScreen(img),
    closePreview: ()=>setFullScreen(null)
  }
}